// frontend/src/data/places.js
const placesData = {
  1: { name: "Aga Khan Palace", image: "/images/aga_khan_palace.jpg" },
  2: { name: "Chatushrungi Mata Temple", image: "/images/chatushrungi_mata_temple.jpg" },
  3: { name: "Dagadusheth Ganapati Temple", image: "/images/dagadusheth_ganapati.jpg" },
  4: { name: "Dehu Gatha Temple", image: "/images/Dehu_Gatha_Temple.jpg" },
  5: { name: "Guruji Talim Ganapati Temple", image: "/images/guruji_talim_ganapati.jpg" },
  6: { name: "Kasba Ganapati Mandir", image: "/images/Kasba_ganapati_mandir.jpg" },
  7: { name: "Kelkar Museum", image: "/images/Kelkar_museum.jpg" },
  8: { name: "Kesariwada", image: "/images/Kesariwada.jpg" },
  9: { name: "Lal Mahal", image: "/images/Lal_mahal.jpg" },
  10: { name: "Lohgad Fort", image: "/images/Lohagad_fort.jpg" },
  11: { name: "Mahatma Phule Museum", image: "/images/Mahatma_phule_museum.jpg" },
  12: { name: "Nana Wada", image: "/images/nana_wada.jpg" },
  13: { name: "Parvati Hill", image: "/images/Parvati_hill.jpg" },
  14: { name: "Pataleshwar Cave Temple", image: "/images/Pataleshwar_cave_temple.jpg" },
  15: { name: "Shaniwar Wada", image: "/images/Shaniwar_wada.jpg" },
  16: { name: "Shinde Chhatri", image: "/images/Shinde_chhatri.jpg" },
  17: { name: "Sinhagad Fort", image: "/images/sinhagad_fort.jpg" },
  18: { name: "Taljai", image: "/images/taljai.jpg" },
  19: { name: "Tambdi Jogeshwari", image: "/images/Tambdi_jogeshwari.jpg" },
  20: { name: "Tulshibaug Ganapati", image: "/images/Tulshibaug_ganapati.jpg"},
  21: { name: "Vishrambaug Wada", image: "/images/Vishrambaug_wada.jpg"}
};

export default placesData;
